import { motion } from 'motion/react';
import { C } from '../../constants/colors.js';
import { tapBounce } from '../../lib/motionPresets.js';

export const Btn = ({children, color=C.primary, onClick, disabled, full, style: sx, className=''}) =>
  <motion.button
    {...tapBounce}
    onClick={onClick}
    disabled={disabled}
    className={`min-h-[48px] rounded-finley-lg px-8 py-3 text-lg font-finley-display font-semibold text-white shadow-finley-md ${full ? 'w-full' : 'w-auto'} ${className}`}
    style={{
      background: disabled ? "#E5E7EB" : color,
      color: disabled ? "#9CA3AF" : "#fff",
      border: "none",
      cursor: disabled ? "default" : "pointer",
      boxShadow: disabled ? "none" : `0 4px 14px ${color}44`,
      ...sx
    }}
  >{children}</motion.button>;
